interface SelectionMarkerProps {
  selected: boolean;
  "aria-hidden"?: boolean;
}

export default function SelectionMarker({
  selected,
  "aria-hidden": ariaHidden,
}: SelectionMarkerProps) {
  return (
    <span
      data-testid="selection-marker"
      aria-hidden={ariaHidden}
      className={`w-6 h-6 rounded-full border-2 shrink-0 flex items-center justify-center ${
        selected ? "border-primary" : "border-[#696966]"
      }`}
    >
      {selected && (
        <span
          data-testid="selection-marker-dot"
          className="w-3 h-3 rounded-full bg-primary"
        />
      )}
    </span>
  );
}
